module.exports = __webpack_public_path__ + "static/img/no-message.2dc6df47.svg";